import React from 'react';
import LegalPageLayout, { LegalSection, LegalList } from '../components/LegalPageLayout';

const TermsOfService: React.FC = () => (
  <LegalPageLayout title="Terms of Service" lastUpdated="1 March 2026">
    <LegalSection title="1. Acceptance of Terms">
      <p>By accessing and using Sahayy ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.</p>
    </LegalSection>

    <LegalSection title="2. Description of Service">
      <p>Sahayy is a mobile application that provides community-based services including but not limited to social networking, messaging, event management, marketplace features, and location-based services. The Service is provided "as is" and on an "as available" basis.</p>
    </LegalSection>

    <LegalSection title="3. User Accounts">
      <p>To use certain features of the Service, you must create an account. You agree to:</p>
      <LegalList items={[
        'Provide accurate, current, and complete information during registration',
        'Maintain and promptly update your account information',
        'Maintain the security of your password and account',
        'Accept responsibility for all activities under your account',
        'Notify us immediately of any unauthorized use of your account',
      ]} />
    </LegalSection>

    <LegalSection title="4. Acceptable Use">
      <p>You agree not to use the Service to:</p>
      <LegalList items={[
        'Violate any applicable laws or regulations',
        'Infringe on the rights of others',
        'Transmit harmful, offensive, or inappropriate content',
        'Engage in harassment, bullying, or threatening behavior',
        'Distribute spam, malware, or other malicious content',
        'Attempt to gain unauthorized access to our systems',
        'Interfere with the proper functioning of the Service',
      ]} />
    </LegalSection>

    <LegalSection title="5. User-Generated Content and Community Guidelines">
      <p><strong style={{ color: "#111827" }}>Zero Tolerance Policy:</strong> Sahayy has zero tolerance for objectionable content or abusive behavior. By using our Service, you agree to these community standards.</p>
      <p><strong style={{ color: "#111827" }}>Prohibited Content:</strong> You may not post, share, or transmit content that is:</p>
      <LegalList items={[
        'Illegal, harmful, threatening, abusive, harassing, defamatory, or invasive of privacy',
        'Hateful, discriminatory, or promotes violence against any individual or group',
        'Contains nudity, sexually explicit material, or inappropriate content',
        'Spam, fraudulent, deceptive, or misleading',
        'Violates intellectual property rights or privacy rights of others',
        'Contains malware, viruses, or other harmful code',
      ]} />
      <p><strong style={{ color: "#111827" }}>Content Moderation:</strong> We actively monitor and filter content using both automated systems and user reports. Users can report objectionable content, and we will review and act on reports promptly.</p>
      <p><strong style={{ color: "#111827" }}>Enforcement Actions:</strong> We may take the following actions for policy violations:</p>
      <LegalList items={[
        'Issue warnings that appear on your profile',
        'Suspend or remove violating content',
        'Temporarily or permanently suspend your account',
        'Report serious violations to appropriate authorities',
      ]} />
    </LegalSection>

    <LegalSection title="6. Content and Intellectual Property">
      <p>You retain ownership of content you post on the Service. By posting content, you grant us a non-exclusive, worldwide, royalty-free license to use, modify, and distribute your content in connection with the Service.</p>
      <p>The Service and its original content, features, and functionality are owned by Sahayy and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.</p>
    </LegalSection>

    <LegalSection title="7. Privacy">
      <p>Your privacy is important to us. Please review our Privacy Policy, which also governs your use of the Service, to understand our practices.</p>
    </LegalSection>

    <LegalSection title="8. Termination">
      <p>We may terminate or suspend your account and access to the Service immediately, without prior notice, for conduct that we believe violates these Terms or is harmful to other users, us, or third parties, or for any other reason.</p>
      <p>You may terminate your account at any time by contacting us or using the account deletion feature in the app.</p>
    </LegalSection>

    <LegalSection title="9. Disclaimers">
      <p>The Service is provided "as is" and "as available" without warranties of any kind. We disclaim all warranties, express or implied, including but not limited to implied warranties of merchantability, fitness for a particular purpose, and non-infringement.</p>
    </LegalSection>

    <LegalSection title="10. Limitation of Liability">
      <p>In no event shall Sahayy be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your use of the Service.</p>
    </LegalSection>

    <LegalSection title="11. Indemnification">
      <p>You agree to defend, indemnify, and hold harmless Sahayy and its officers, directors, employees, and agents from and against any claims, liabilities, damages, judgments, awards, losses, costs, expenses, or fees arising out of or relating to your violation of these Terms or your use of the Service.</p>
    </LegalSection>

    <LegalSection title="12. Governing Law">
      <p>These Terms shall be interpreted and governed by the laws of the jurisdiction in which Sahayy operates, without regard to its conflict of law provisions.</p>
    </LegalSection>

    <LegalSection title="13. Changes to Terms">
      <p>We reserve the right to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days notice prior to any new terms taking effect.</p>
    </LegalSection>

    <LegalSection title="14. Contact Information">
      <p>If you have any questions about these Terms of Service, please contact us at:</p>
      <p>Email: <a href="mailto:care@sahayy.com" style={{ color: '#FF9900' }}>care@sahayy.com</a></p>
    </LegalSection>
  </LegalPageLayout>
);

export default TermsOfService;
